export enum JobTypeEnum {
  ProteinBinderDesign = "protein_binder_design",
  // VhhDesign = "vhh_design",
  VhhDesign = "antibody_design_lite",
  AbAgDocking = "ab_ag_dock_lite",
  PeptideDesignLite = "peptide_design_lite",
}

export enum JobStatusEnum {
  Pending = "pending",
  Executing = "executing",
  Finished = "finished",
  Failed = "failed",
}

export enum BinderDesignTypeEnum {
  ProteinChain = "proteinChain",
  DnaSequence = "dnaSequence",
  DnaSequenceDs = "dnaSequence_ds",
  RnaSequence = "rnaSequence",
  RnaSequenceDs = "rnaSequence_ds",
  Ligand = "ligand",
  LigandCCD = "ligand_ccd",
}

export enum DownloadTypeEnum {
  ByJobs = "by_jobs",
  ByFileIds = "by_file_ids",
}

export enum TaskStatusEnum {
  Pendding = 1,
  Success = 5,
  Failed = 6,
  Expired = 9,
}

export enum VhhDesignTypeEnum {
  PdbID = "pdb_id",
  UniProtID = "uni_prot_id",
  AntigenSequence = "antigen_sequence",
  UploadStructure = "upload_structure",
}

export enum AntibodyDesignBinderTypeEnum {
  Vhh = "vhh",
  Scfv = "scfv",
}

export enum PeptideDesignBinderTypeEnum {
  LinPep = "linear_peptide",
  DisulPep = "disulphide_cyclized_peptide",
  CycPep = "backbone_cyclized_peptide",
}
